/**
 * EGON route types + mapper. Field names of the API (incl. the joined service code)
 * are isolated here so they are easy to adjust if the backend contract changes.
 */

export interface EgonRouteApiType {
    ID: number;
    ID_SERVICE_CODE: number;
    SERVICE_CODE_VALUE?: string;
    SERVICE_CODE_LABEL?: string;
    SHIPPER_CODE?: string;
    COUNTRY_CODE: string;
    EGON_DELIVERY_ID: number;
    EGON_DELIVERY_NAME?: string | null;
    EGON_TRANSFER_TYPE?: number | null;
    ENABLED: number;
    NOTE?: string | null;
    CREATED_AT?: string;
    UPDATED_AT?: string | null;
    UPDATED_BY?: string | null;
}

export interface EgonRouteType {
    ID?: number;
    ID_SERVICE_CODE?: number;
    SERVICE_CODE_VALUE?: string;
    SERVICE_CODE_LABEL?: string;
    SHIPPER_CODE?: string;
    COUNTRY_CODE?: string;
    COUNTRY_CODES?: string[];
    EGON_DELIVERY_ID?: number;
    EGON_DELIVERY_NAME?: string | null;
    EGON_TRANSFER_TYPE?: number | null;
    ENABLED?: number;
    NOTE?: string | null;
    CREATED_AT?: string;
    UPDATED_AT?: string | null;
    UPDATED_BY?: string | null;
}

export const mapEgonRoute = (item: EgonRouteApiType): EgonRouteType => ({ ...item });

export interface EgonRoutesListStateType {
    data: EgonRouteType[] | null;
    loading: boolean;
    error: boolean;
}

export interface EgonRouteDetailStateType {
    loading: boolean;
    data: EgonRouteType | null;
    deleted: boolean;
    created: boolean;
    error: boolean;
}

export interface EgonRouteDetailResType {
    data: EgonRouteType;
}

export interface EgonRouteCreateBodyType {
    ID_SERVICE_CODE: number;
    COUNTRY_CODES: string[];
    EGON_DELIVERY_ID: number;
    EGON_DELIVERY_NAME: string | null;
    EGON_TRANSFER_TYPE: number | null;
    ENABLED: number;
    NOTE: string | null;
}

export interface EgonRouteUpdateBodyType {
    ID_SERVICE_CODE: number;
    COUNTRY_CODE: string;
    EGON_DELIVERY_ID: number;
    EGON_DELIVERY_NAME: string | null;
    EGON_TRANSFER_TYPE: number | null;
    ENABLED: number;
    NOTE: string | null;
}

export interface EgonDeliveryType {
    id: number;
    name: string;
    transferType: number | null;
    transferTypeName: string | null;
    codAvailability: boolean;
}

export interface EgonDeliveriesStateType {
    data: EgonDeliveryType[] | null;
    loading: boolean;
    error: boolean;
}
